import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapActiveMobile = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 32,
	viewBox: "0 0 33 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_2452_9156)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2452_9156",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 33,
			height: 32,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .5,
				width: 32,
				height: 32,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2452_9156)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5 27.2818L12.5 24.4818L6.76169 26.7021C6.36858 26.8543 6.00446 26.8108 5.66935 26.5714C5.33424 26.3321 5.16669 26.0048 5.16669 25.5894V8.10244C5.16669 7.83911 5.23724 7.60277 5.37835 7.39344C5.51924 7.18411 5.71713 7.03244 5.97202 6.93844L12.5 4.71777L20.5 7.51777L26.2384 5.29744C26.6315 5.14522 26.9956 5.18233 27.3307 5.40877C27.6658 5.63522 27.8334 5.95189 27.8334 6.35878V23.9484C27.8334 24.2202 27.7565 24.4587 27.6027 24.6638C27.4487 24.8689 27.2401 25.0184 26.977 25.1124L20.5 27.2818ZM19.5 24.8358V9.23577L13.5 7.13811V22.7381L19.5 24.8358ZM21.5 24.8358L25.8334 23.3998V7.59977L21.5 9.23577V24.8358ZM7.16669 24.3998L11.5 22.7381V7.13811L7.16669 8.59977V24.3998Z",
				fill: "white"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_2452_9156",
		x: .5,
		y: 0,
		width: 33,
		height: 33,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.112809 0 0 0 0 0.417748 0 0 0 0 0.518555 0 0 0 1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_2452_9156"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_2452_9156",
				result: "shape"
			})
		]
	}) })]
});
export default SvgMapActiveMobile;
